import { render, staticRenderFns } from "./registerTransfer.vue?vue&type=template&id=2ba382cb&scoped=true"
import script from "./registerTransfer.js?vue&type=script&lang=js&external"
export * from "./registerTransfer.js?vue&type=script&lang=js&external"
import style0 from "./registerTransfer.vue?vue&type=style&index=0&id=2ba382cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba382cb",
  null
  
)

export default component.exports